module.exports = __webpack_public_path__ + "img/booking.edb29fb0.svg";